module.exports = __webpack_public_path__ + "static/media/usine-nouvelle.be9e0b28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/usine-nouvelle.png
// module id = 1835
// module chunks = 0